module.exports = __webpack_public_path__ + "static/media/checkmark.57fa6abd.svg";